import { AxiosResponse } from 'axios';
import { RestServiceConnection } from '../restServiceConnection';

const ENDPOINT = '/wind-turbine';

export class WindTurbineService extends RestServiceConnection {


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA DE AEROGENERADORES
     * @EN GETS THE LIST OF WIND TURBINES
     */
    // -------------------------------------------------------------------------------------------------------------
    listWindTurbines = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE UN AEROGENERADOR POR SU ID
     * @EN GETS A WIND TURBINE BY ITS ID
     * 
     * @param windTurbineId
     */
    // -------------------------------------------------------------------------------------------------------------
    getWindTurbineById = async (windTurbineId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get',
            data: { 
                id: windTurbineId 
            },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES CREA UN AEROGENERADOR
     * @EN CREATES A WIND TURBINE
     * 
     * @param windTurbine
     */
    // -------------------------------------------------------------------------------------------------------------
    createWindTurbine = async (windTurbine: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/create',
            data: windTurbine,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ACTUALIZA UN AEROGENERADOR
     * @EN UPDATES A WIND TURBINE
     * 
     * @param windTurbine
     */
    // -------------------------------------------------------------------------------------------------------------
    editWindTurbine = async (windTurbine: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/edit',
            data: windTurbine,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA UN AEROGENERADOR
     * @EN DELETES A WIND TURBINE
     * 
     * @param windTurbineId
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteWindTurbine = async (windTurbineId: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete',
            data: { 
                id: windTurbineId 
            },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------

    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES ELIMINA TODOS LOS AEROGENERADORES SELECCIONADOS
     * @EN DELETES ALL SELECTED WIND TURBINES
     * 
     * @param windTurbinesIds
     */
    // -------------------------------------------------------------------------------------------------------------
    deleteMultiWindTurbine = async (windTurbinesIds: string[]) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete-multi',
            data: { 
                ids: windTurbinesIds
            },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------


    // -------------------------------------------------------------------------------------------------------------
    /**
     * @ES OBTIENE LA LISTA DE AEROGENERADORES
     * @EN GETS THE LIST OF WIND TURBINES
     */
    // -------------------------------------------------------------------------------------------------------------
    listForSelect = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list-select',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }
    // -------------------------------------------------------------------------------------------------------------
}